import { createFileRoute, type SearchSchemaInput } from '@tanstack/react-router'
import { z } from 'zod'

import { StatsPage } from '@/features/stats/stats-page'
import type { StatsSearch } from '@/features/stats/stats-range'

const isoDay = z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .optional()
    .catch(undefined)

/**
 * The range lives in the URL so a view is shareable and survives a refresh, which is
 * the point of a dashboard someone screenshots into chat. `catch` on every field
 * rather than a throw: a hand-edited date should degrade to the default range, not to
 * an error page. `resolveRange` handles the rest, including inverted and future days.
 */
const searchSchema = z.object({
    from: isoDay,
    to: isoDay,
    tab: z.enum(['overview', 'money', 'play', 'growth']).catch('overview'),
    compare: z.boolean().catch(true)
})

export const Route = createFileRoute('/_app/stats')({
    // Tagged with `SearchSchemaInput` so `<Link to="/stats">` does not have to spell
    // out a range it does not care about, while `useSearch()` still reads a
    // fully-defaulted object.
    validateSearch: (
        search: { from?: unknown; to?: unknown; tab?: unknown; compare?: unknown } & SearchSchemaInput
    ): StatsSearch => searchSchema.parse(search ?? {}),
    component: StatsPage,
    staticData: { crumb: 'Stats' }
})
